import cx from 'classnames';
import React from 'react';

import * as Styled from './styled';

export type ComponentProps = {
  /**
   * Optional wrapper class name attached
   */
  className?: string;
  /**
   * Text of the title to show for the transaction
   */
  text: string;
  /**
   * Optional transaction image url
   */
  imgUrl?: string;
  /**
   * Optional primary background color
   */
  backgroundColorPrimary?: string;
  /**
   * Optional secondary background color
   */
  backgroundColorSecondary?: string;
};

export const Title: React.FC<ComponentProps> = ({
  className = '',
  text,
  imgUrl,
  backgroundColorPrimary = '',
  backgroundColorSecondary = ''
}) => {
  return (
    <Styled.Wrapper
      className={cx({ [className]: !!className })}
      backgroundColor={backgroundColorPrimary}>
      <Styled.Text>
        <Styled.TextInner>{text}</Styled.TextInner>
      </Styled.Text>
      <Styled.ImgWrapper
        imgUrl={imgUrl}
        backgroundColorPrimary={backgroundColorPrimary}
        backgroundColorSecondary={backgroundColorSecondary}>
        <Styled.Img />
      </Styled.ImgWrapper>
    </Styled.Wrapper>
  );
};

export default Title;
